/** Which pipeline produced this transcript item */
export type TranscriptSource =
  | 'rest-stream'
  | 'rest-fallback'
  | 'rest-recovery'
  | 'live-transcript'
  | 'live-text'
  | 'live-gate'
  | 'system';

/** Options for appendTranscriptItem */
export interface TranscriptAppendOptions {
  /** Which pipeline is producing this item */
  source: TranscriptSource;
  /** Unique turn ID (loading ID or message ID) */
  turnId: string;
  /** Whether to persist to server after append (default: false) */
  persistToServer?: boolean;
  /** Whether to sync clientSessionViewStore (default: true) */
  syncUnifiedContext?: boolean;
}
/**
 * Generate a unique ID for transcript items using crypto.randomUUID().
 * Falls back to Date.now()+random for environments without crypto.
 */
export function generateTranscriptId(prefix = 'msg'): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}-${crypto.randomUUID()}`;
  }
  // Fallback for older environments
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

/**
 * Response ownership is enforced by the server Session Coordinator before any
 * visible output is emitted. The browser no longer keeps an ownership registry.
 */
export function shouldSuppressModelMessage(
  _source: TranscriptSource,
  _turnId?: string
): boolean {
  return false
}
